import {Component, OnDestroy} from '@angular/core';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { TranslateService } from '@ngx-translate/core';
import {FuseConfigService} from './core/services/config.service';
import { AppConfig } from './app.config';
import {FuseNavigationService} from './core/components/navigation/navigation.service';
import {FrontUserService} from './core/services/frontUsers.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {interval, Subscription} from 'rxjs';
import {PlatformsService} from './core/services/platforms.service';
import { ServerService } from './core/services/server.service';
import { Router } from '@angular/router';
import { RecommendationService } from './core/services/recommendation.service';
import { FuseDeleteDialogComponent } from './core/components/delete-dialog/delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from './core/services/users.service';

@Component({
    selector: 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnDestroy
{
  public intervallTimer = interval(30000);
  private subscriptions =  new Subscription();
    constructor(
        private fuseSplashScreen: FuseSplashScreenService,
        private translate: TranslateService,
        private fuseConfig: FuseConfigService,
        private appConfig: AppConfig,
        private navigationService: FuseNavigationService,
        private frontUserService: FrontUserService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private platformsService: PlatformsService,
        private serverService: ServerService,
        private router: Router,
        private recommendationService: RecommendationService,
        public dialog: MatDialog,
        public userService: UserService

    )
    {

      this.matIconRegistry.addSvgIcon(
        `bug-custom`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/bug.svg`)
      );
      this.matIconRegistry.addSvgIcon(
        `lamp`,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/idee.svg`)
      );
      this.fuseConfig.setUserName(localStorage.getItem('name'));
      this.fuseConfig.setUserEmail(localStorage.getItem('userEmail'));
      this.fuseConfig.setUserId(localStorage.getItem('id'));
      this.fuseConfig.userId_Sig.set(localStorage.getItem('id'));
      this.fuseConfig.setCanRecommend(localStorage.getItem('canRecommend'));
      this.fuseConfig.setAllowCompetency(localStorage.getItem('allowCompetency'));
      this.fuseConfig.setECall(localStorage.getItem('eCall'));
      this.fuseConfig.setWhatsApp(localStorage.getItem('whatsapp'));
      this.fuseConfig.setRole(localStorage.getItem('role'));
      this.fuseConfig.role_Sig.set(localStorage.getItem('role'));
      if (localStorage.getItem('role') === 'organisationAdmin') {
        this.fuseConfig.setOrganizationId(localStorage.getItem('organizationId'));
        this.fuseConfig.organizationId_Sig.set(localStorage.getItem('organizationId'));
      } else {
        this.fuseConfig.setOrganizationId(null);
        this.fuseConfig.organizationId_Sig.set(null);
      }
      this.fuseConfig.setLogo(localStorage.getItem('logo'));
      this.fuseConfig.setPrivacy(localStorage.getItem('privacy'));
      this.fuseConfig.setImpersonation(localStorage.getItem('impersonation'));
      this.fuseConfig.setOrganizationName(localStorage.getItem('organizationName'));
      this.fuseConfig.setOrganizationType(localStorage.getItem('organizationType'));
      this.fuseConfig.setCountry(JSON.parse(localStorage.getItem('country')));
      this.fuseConfig.setCity(JSON.parse(localStorage.getItem('city')));
      this.appConfig.setAuthToken(localStorage.getItem('accessToken'));
      console.log('InitApp');
        // Add languages
        this.translate.addLangs(['en', 'de']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
      if (localStorage.getItem('lang')) {
        this.translate.use(localStorage.getItem('lang'));
      }
      // this.updateUserBadge();
      // this.appConfig.authToken.subscribe(token => {
      //   if (token) {
      //     setTimeout(() => {
            this.fuseConfig.getProjectSettings().subscribe((res: any) => {
              if (res && res.id) {
                delete res.id;
                this.fuseConfig.setProjectSettings(res);
                document.title = res.pageTitle;
              }
            });
      //     }, 1000);
      //   }
      // })
      let orgId = localStorage.getItem('organizationId');
      if (localStorage.getItem('role') === 'organisationAdmin' && orgId) {
        this.platformsService.getByOrganizationId(orgId, true).subscribe(res => {
          this.fuseConfig.setPlatforms(res);
        });
      }
    }

  updateUserBadge()
  {
    this.subscriptions.add( this.frontUserService.getNumberOfNew().subscribe((res) => {
      const mailNavItem = this.navigationService.getNavigationItem('frontusers.frontNoVerify');
      console.log(mailNavItem);
      // Update the badge title
      mailNavItem.badge.title = res;
    }));
    this.subscriptions.add(  this.intervallTimer.subscribe(() => {
      this.subscriptions.add( this.frontUserService.getNumberOfNew().subscribe((res) => {
        const mailNavItem = this.navigationService.getNavigationItem('frontusers.frontNoVerify');
        console.log(mailNavItem);
        // Update the badge title
        mailNavItem.badge.title = res;
      }));
    }));

  }

  checkRecommendationCount() {
      this.subscriptions.add(
        this.recommendationService.getRecommendationsCount().subscribe((res: any) => {
          const recommendationNavItem = this.navigationService.getNavigationItem('recommendation');
          if (recommendationNavItem) recommendationNavItem.badge = +res.event + +res.blog + +res.elearning;
          let goTo = '';
          if (+res.event) {
            const eventNavItem = this.navigationService.getNavigationItem('recommendation.recommendation-event');
            if (eventNavItem) eventNavItem.badge = +res.event;
            goTo = 'recommendation-event';
          }
          if (+res.blog) {
            const blogNavItem = this.navigationService.getNavigationItem('recommendation.recommendation-blog');
            if (blogNavItem) blogNavItem.badge = +res.blog;
            if (!goTo) goTo = 'recommendation-blog';
          }
          if (+res.elearning) {
            const elearningNavItem = this.navigationService.getNavigationItem('recommendation.recommendation-elearning');
            if (elearningNavItem) elearningNavItem.badge = +res.elearning;
            if (!goTo) goTo = 'recommendation-elearning';
          }
          if ((+res.event + +res.blog + +res.elearning) > 0) {
            const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
              width: '400px' ,
              data: {title: 'new_recommendation' , message: 'new_recommendation_msg'}
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                if (goTo) {
                  this.router.navigate([ './pages/recommendation/' + goTo ]);
                }
              }
            })
          }
          this.userService.updateLastSeen().subscribe();
        })
      )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
      this.appConfig.authToken.subscribe((res: any) => {
        if (res) {
          setTimeout(() => {
            this.checkRecommendationCount();
          }, 3000);
        }
      });
    // this.checkServer();
    // setInterval(() => {
    //   this.checkServer();
    // }, 300000);
  }

  checkServer(){
    this.serverService.checkServer().subscribe({
      next: (res) => {
        this.serverService.updateServer.next(true);
      },
      error: (err) => {
        this.serverService.updateServer.next(false);
        this.router.navigate([ './pages/serverOnService' ]);
      }
    })
  }
}
